import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import "./DeleteConfirmationModal.css";
import { Loader } from "../Loader/Loader";

const DeleteConfirmationModal = ({
  type,
  closeModal,
  showModal,
  confirmDelete,
  loading = false,
}) => {
  return (
    <Modal style={{ padding: 0 }} isOpen={showModal} centered={true}>
      {!loading ? (
        <div className="">
          <ModalHeader
            className="border-0"
            toggle={() => closeModal(!showModal)}
          >
            Delete Alert
          </ModalHeader>
          <div className="px-2">
            <ModalBody style={{ padding: 1 }}>
              <h5 style={{ color: "#000" }}>
                {`Do you want to delete this ${type} ?`}
              </h5>
            </ModalBody>
            <ModalFooter style={{ marginTop: 5, padding: "1 1 0 1" }}>
              <button className="btn btn-green" onClick={confirmDelete}>
                Yes
              </button>
              <button
                className="btn btn-grey"
                onClick={() => closeModal(!showModal)}
              >
                No
              </button>
            </ModalFooter>
          </div>
        </div>
      ) : (
        <div className="m-4">
          <Loader />
        </div>
      )}
    </Modal>
  );
};

export default DeleteConfirmationModal;
